module.exports = __webpack_public_path__ + "img/loading_bottom.0cb4c643.jpg";